module.exports = __webpack_public_path__ + "img/deco-3.5274f5ce.svg";